var pic = require('../modules/pic/');
var Mask = require('../modules/mask/');
var LiveSlide = require('../modules/slide/');

var liveConfig = {};
liveConfig.maxWidthUrl = '//d.ifengimg.com/mw950/';


var mask,liveslide;



var Ppt = function(options){
	this.init(options);
};

Ppt.prototype.init = function(options){
	this.options = options;
	var defaultData = {
        'pictures':options.pictures,
        'index':'0',
        'imageSrc':options.pictures[0].url,
		'picLength':options.pictures.length
    };

	if(typeof mask === 'undefined'){
		mask = new Mask();
	}
	if(typeof liveslide === 'undefined'){
		liveslide = new LiveSlide(defaultData);
	}

	this.initDom();

	this.bindDomEvent(options.pictures);

};

Ppt.prototype.initDom = function () {
    var picHtml = pic(this.options.pictures,this.options.mid);
    this.el = $(picHtml);
};

Ppt.prototype.bindDomEvent = function(pictures){
	var _this = this;
	this.el.on('click','[data-index]',function(){
		var index = $(this).data('index');
		console.log("index==",index);
		 _this.show(pictures,index);

	    $('.mod-picPop').on('click',_this.hide);
	})
};

Ppt.prototype.hide = function(){
	mask.hide();
	liveslide.hide();
};

Ppt.prototype.show = function(pictures,index){

	    mask.show();

	    liveslide.show(pictures,index);
};
Ppt.prototype.renderTo = function (parentNode) {
    parentNode.appendChild($(this.el)[0]);
};


module.exports = Ppt;


// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.pic.pc/app/lib/ppt.js